import {
    calendarDayOfWeek_Day,
    calendarDayOfWeek_Weekday,
    calendarDayOfWeek_WeekendDay,
} from './getLocalizedDayOfWeek.locstring.json';
import { calendarDayOfWeek_Saturday } from 'owa-locstrings/lib/strings/calendardayofweek_saturday.locstring.json';
import { calendarDayOfWeek_Friday } from 'owa-locstrings/lib/strings/calendardayofweek_friday.locstring.json';
import { calendarDayOfWeek_Thursday } from 'owa-locstrings/lib/strings/calendardayofweek_thursday.locstring.json';
import { calendarDayOfWeek_Wednesday } from 'owa-locstrings/lib/strings/calendardayofweek_wednesday.locstring.json';
import { calendarDayOfWeek_Tuesday } from 'owa-locstrings/lib/strings/calendardayofweek_tuesday.locstring.json';
import { calendarDayOfWeek_Monday } from 'owa-locstrings/lib/strings/calendardayofweek_monday.locstring.json';
import { calendarDayOfWeek_Sunday } from 'owa-locstrings/lib/strings/calendardayofweek_sunday.locstring.json';
import loc from 'owa-localize';
import DayOfWeekType from '../../store/schema/DayOfWeekType';

const strings = {
    calendarDayOfWeek_Day,
    calendarDayOfWeek_Weekday,
    calendarDayOfWeek_WeekendDay,
    calendarDayOfWeek_Saturday,
    calendarDayOfWeek_Friday,
    calendarDayOfWeek_Thursday,
    calendarDayOfWeek_Wednesday,
    calendarDayOfWeek_Tuesday,
    calendarDayOfWeek_Monday,
    calendarDayOfWeek_Sunday,
};

export default function getLocalizedDayOfWeek(dayOfWeek: DayOfWeekType): string {
    return loc(strings['calendarDayOfWeek_' + dayOfWeek]);
}
